import { Modal, ModalBody, ModalHeader } from "reactstrap";
import ReactPlayer from "react-player";
function ViewImgAndPdf({
  isOpen,
  toggleModal,
  titleName,
  images,
  currentImageIndex,
  fileType,
}) {
  const currentImage = images?.[currentImageIndex] || "";
  const isPdf = ["pdf", "application/pdf"].includes(fileType);
  const isYouTube = fileType === "youtube"; 
  return (
    <Modal isOpen={isOpen} toggle={toggleModal} size="lg">
      <ModalHeader toggle={toggleModal}>{titleName}</ModalHeader>
      <ModalBody>
        {currentImage && (
          <div style={{ textAlign: "center" }}>
            {isPdf ? (
              <iframe
                className="img-thumbnail"
                src={currentImage}
                style={{ height: "600px", width: "800px", objectFit: "cover" }}
                title="PDF Preview"
              />
            ) : isYouTube ? (
              <ReactPlayer
                src={currentImage}
                controls
                width="auto"
                height={480}
              />
            ) : (
              <img
                className="img-thumbnail"
                src={currentImage}
                alt="Selected"
                style={{
                  height: "auto",
                  maxHeight: "600px",
                  width: "650px",
                  objectFit: "cover",
                }}
              />
            )}
          </div>
        )}
      </ModalBody>
    </Modal>
  );
}

export default ViewImgAndPdf;
